import React from 'react'

function Members() {
    const members = Array.from({ length: 12 }, (_, index) => ({
        id: index + 1,
        name: `Rahul Jain`,
        members: 101,
        image: '/assets/impact/img5.png',
    }));

    return (
        <>
            <section className="gallery-section md:pt-[50px] pt-[50px] md:pb-[120px] pb-[50px] mt-[80px]">
                <h6 className="text-center max-w-[572px] w-full mx-auto text-heading-primary text-[#2D190D] pb-[50px]">Members</h6>
                <div className='md:px-[75px] px-[20px] grid md:grid-rows-2 grid-rows-1 md:grid-cols-4 grid-cols-1 gap-[20px]'>
                    {members.map((member) => (
                        <div key={member.id} className='rounded-[16px] bg-[#FFFFFF] pb-[23px] relative'>
                            <div
                                className='h-[81px] rounded-t-[16px]'
                                style={{ background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)" }}
                            />
                            <img
                                src={member.image}
                                className='absolute top-[29px] left-[50%] translate-x-[-50%]'
                                alt=""
                            />
                            <h6 className="font-[700] font-manrope text-[20px] text-[#333333] text-center pt-[59px]">
                                {member.name}
                            </h6>
                            <p className="pt-[2px] font-[400] font-manrope text-[16px] leading-[20px] text-[#4D4D4D] text-center pb-[16px]">
                                {member.members} Members
                            </p>
                            <div className='flex justify-center'>
                                <button
                                    className='text-[#FFFFFF] font-[700] font-manrope text-[18px] tracking-[-0.3px] py-[13px] px-[44px] rounded-[10px]'
                                    style={{ background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)" }}
                                >
                                    Join Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}

export default Members